import { render, staticRenderFns } from "./AnswerStatisticModal.vue?vue&type=template&id=2fc07014&scoped=true"
import script from "./AnswerStatisticModal.vue?vue&type=script&lang=js"
export * from "./AnswerStatisticModal.vue?vue&type=script&lang=js"
import style0 from "./AnswerStatisticModal.vue?vue&type=style&index=0&id=2fc07014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc07014",
  null
  
)

export default component.exports